<template>
  <main class="schedule">
    <Info class="u-hidden--from-ipadP" :allways="true"/>
    <AppTitle
      class="c-title--light"
      :data="{ content: 'Schedule.' }"
      data-item="title"
      :isAnimated="false"
    />
    <AppLine class="u-hidden--until-ipadL" data-item="line" :isAnimated="false"/>
    <section class="timetable">
      <transition @enter="enter" appear>
        <TimeTable :data="getSchedules.data" />
      </transition>
    </section>

    <AppShowcase type="venues" />

    <AppSponsor />

    <AppFooter />
  </main>
</template>

<script>
import anime from 'animejs';
import { mapGetters } from 'vuex';

import AppLine from '@/components/AppLine.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppShowcase from '@/components/AppShowcase.vue';
import AppSponsor from '@/components/AppSponsor.vue';
import AppFooter from '@/components/AppFooter.vue';
import Info from '@/components/Info.vue';
import TimeTable from '@/components/TimeTable.vue';

import medusa from '@/scripts/medusa';
import { initials, animations } from '@/scripts/fx';

import schedules from '@/assets/data/contents/schedules.json';

export default {
  name: 'Schedule',
  components: {
    AppLine,
    AppTitle,
    AppShowcase,
    AppSponsor,
    AppFooter,
    TimeTable,
    Info,
  },
  data() {
    return {
      schedules,
    };
  },
  computed: {
    ...mapGetters(['currentPage', 'contentReady']),

    getSchedules() {
      return this.schedules[this.$route.params.city];
    },
  },
  mounted() {
    medusa.recalculateTargets(this.$el);
    this.enterAnimation();
  },
  methods: {
    enter(el, done) {
      anime({ targets: el, opacity: [0, 1] });
      const items = [...el.querySelectorAll('[data-lazyanimation="fade"]')];
      const titles = [...el.querySelectorAll('[data-lazyanimation="title"]')];
      items.forEach(item => initials.get('fade')(item, 80));
      titles.forEach(title => initials.get('title')(title));
      medusa.ref.pushToTarget('scrollAnimations', items);
      medusa.ref.pushToTarget('scrollAnimations', titles);
      medusa.prevNodes.push(...items);
      medusa.prevNodes.push(...titles);

      done();
    },
    enterAnimation() {
      const title = this.$el.querySelector('[data-item="title"] h3');
      const line = this.$el.querySelector('[data-item="line"]');
      initials.get('line')(line);
      initials.get('title')(title);

      animations.get('title')(title);
      animations.get('line')(line, 300);
    },
  },
  beforeDestroy() {
    medusa.removePrevTargets();
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  .info {
    position: relative;
    top: unset;
    width: 100%;

    transform: translateY($unit-vh * -2);
    z-index: unset;
  }
}
</style>
<style lang="scss">
.timetable {
  min-height: 50vh;
}
</style>
